"use client";

import { createContext } from "react";

/** Optional dialog-state observer, independent of analytics and the modal bundle. */
export const JanoshikModalStateContext = createContext<((open: boolean) => void) | undefined>(undefined);
